import { render, staticRenderFns } from "./ats-candidate-table.vue?vue&type=template&id=4db1c119&scoped=true"
import script from "./ats-candidate-table.vue?vue&type=script&lang=ts"
export * from "./ats-candidate-table.vue?vue&type=script&lang=ts"
import style0 from "./ats-candidate-table.vue?vue&type=style&index=0&id=4db1c119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1c119",
  null
  
)

export default component.exports